import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectOption } from '../../design-system/components/listbox/listbox.component';

const EXAMPLE_LOGO =
  'data:image/svg+xml;base64,' +
  btoa(
    '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="28" viewBox="0 0 120 28">' +
      '<rect x="0.5" y="0.5" width="119" height="27" rx="3" fill="#FAFAFA" ' +
      'stroke="#D4D4D4" stroke-dasharray="3 2"/>' +
      '<text x="50%" y="50%" font-family="Arial, sans-serif" font-size="10" ' +
      'letter-spacing="1.5" fill="#8A8A8A" text-anchor="middle" ' +
      'dominant-baseline="central">LOGO</text></svg>'
  );

@Component({
  selector: 'app-components-showcase',
  template: `
    <div class="aav-scope view-wrapper">
      <div class="container">
        <div class="col-md-12 flex flex-col gap-6 py-6">
          <header class="flex flex-col gap-1">
            <h1 class="text-aav-headline-small text-aav-on-surface">Componentes</h1>
            <p class="text-aav-body-small text-aav-on-surface-variant">
              Catálogo dos componentes Angular disponíveis.
            </p>
          </header>

          <section
            class="flex flex-col gap-4 rounded-aav-md border-[1px] border-solid border-aav-outline bg-aav-surface p-6"
          >
            <div class="flex flex-col gap-1">
              <h2 class="text-aav-title-medium-strong text-aav-on-surface">
                &lt;app-portal-card&gt; &mdash; com contador
              </h2>
              <p class="text-aav-body-small text-aav-on-surface-variant">
                Com <code>count</code>, exibe o total de veículos ao lado do logo. Sem
                <code>logo</code>, exibe o nome do portal.
              </p>
            </div>

            <div class="flex flex-wrap items-center gap-x-8 gap-y-2">
              <app-portal-card name="Portal Exemplo" [logo]="exampleLogo" [count]="12">
              </app-portal-card>

              <app-portal-card name="Portal" [count]="3"></app-portal-card>
            </div>
          </section>

          <section
            class="flex flex-col gap-4 rounded-aav-md border-[1px] border-solid border-aav-outline bg-aav-surface p-6"
          >
            <div class="flex flex-col gap-1">
              <h2 class="text-aav-title-medium-strong text-aav-on-surface">
                &lt;app-portal-card clickable&gt;
              </h2>
              <p class="text-aav-body-small text-aav-on-surface-variant">
                Com <code>clickable</code>, vira um card de 120 &times; 40 com borda e clique. A
                borda assume a cor primária ao passar o mouse. Emite <code>clicked</code>.
              </p>
            </div>

            <div class="flex flex-wrap items-center gap-3">
              <app-portal-card
                name="Portal Exemplo"
                [logo]="exampleLogo"
                clickable
                (clicked)="onHireClick()"
              ></app-portal-card>
            </div>

            <p class="text-aav-body-small text-aav-on-surface-variant" role="status">
              {{ clicks === 0 ? 'Nenhum clique ainda.' : 'Cliques: ' + clicks }}
            </p>
          </section>

          <section
            class="flex flex-col gap-4 rounded-aav-md border-[1px] border-solid border-aav-outline bg-aav-surface p-6"
          >
            <div class="flex flex-col gap-1">
              <h2 class="text-aav-title-medium-strong text-aav-on-surface">
                &lt;aav-filter-panel&gt;
              </h2>
              <p class="text-aav-body-small text-aav-on-surface-variant">
                Card de filtros com t&iacute;tulo, grade de campos e bot&atilde;o de
                a&ccedil;&atilde;o. Envolva-o em um <code>&lt;form [formGroup]&gt;</code> e projete
                os campos dentro; <code>columns</code> aceita um n&uacute;mero de colunas ou uma
                lista de tracks CSS (<code>'2fr 1fr'</code>). Sem <code>submitLabel</code>, o
                bot&atilde;o n&atilde;o &eacute; renderizado.
              </p>
            </div>

            <form [formGroup]="filterForm" (ngSubmit)="onFilterSubmit()">
              <aav-filter-panel
                heading="Pesquisar altera&ccedil;&atilde;o"
                submitLabel="Pesquisar"
                [columns]="3"
              >
                <aav-text-field
                  type="date"
                  size="dense"
                  leadingIcon="event"
                  formControlName="date"
                  label="Data"
                ></aav-text-field>

                <aav-listbox
                  class="w-full"
                  shape="dense"
                  formControlName="entityId"
                  label="Loja"
                  ariaLabel="Loja"
                  [options]="entityOptions"
                ></aav-listbox>

                <aav-text-field
                  size="dense"
                  formControlName="plate"
                  label="Placa"
                  placeholder="Placa"
                  [maxlength]="8"
                ></aav-text-field>
              </aav-filter-panel>
            </form>

            <p class="text-aav-body-small text-aav-on-surface-variant" role="status">
              {{ searches === 0 ? 'Nenhuma pesquisa ainda.' : 'Pesquisas: ' + searches }}
            </p>
          </section>

          <section
            class="flex flex-col gap-4 rounded-aav-md border-[1px] border-solid border-aav-outline bg-aav-surface p-6"
          >
            <div class="flex flex-col gap-1">
              <h2 class="text-aav-title-medium-strong text-aav-on-surface">&lt;aav-dialog&gt;</h2>
              <p class="text-aav-body-small text-aav-on-surface-variant">
                Moldura de di&aacute;logo: cabe&ccedil;alho fixo, corpo rol&aacute;vel e
                rodap&eacute; fixo. O conte&uacute;do padr&atilde;o vai para o corpo; as
                a&ccedil;&otilde;es entram em um
                <code>&lt;ng-container aavDialogActions&gt;</code> &mdash; sem ele o rodap&eacute;
                n&atilde;o &eacute; renderizado. O <code>X</code> emite <code>dismissed</code>. Quem
                usa define a largura no pr&oacute;prio <code>:host</code>.
              </p>
            </div>

            <div class="flex h-[320px] w-[420px] max-w-full shadow-aav-elevation-2">
              <aav-dialog
                heading="Detalhes do hist&oacute;rico"
                subheading="17/07/2023 &middot; Loja Exemplo"
                closeLabel="Fechar"
                (dismissed)="onDialogDismiss()"
              >
                <div class="px-[1.5rem] py-[1.25rem] text-aav-body-medium text-aav-on-surface">
                  <p *ngFor="let line of dialogLines" class="mb-[0.75rem]">{{ line }}</p>
                </div>

                <ng-container aavDialogActions>
                  <aav-button variant="outlined-neutral" class="uppercase"
                    >Ver ve&iacute;culo</aav-button
                  >
                  <aav-button variant="filled" class="uppercase" (clicked)="onDialogDismiss()">
                    Fechar
                  </aav-button>
                </ng-container>
              </aav-dialog>
            </div>

            <p class="text-aav-body-small text-aav-on-surface-variant" role="status">
              {{ dismissals === 0 ? 'Nenhum fechamento ainda.' : 'Fechamentos: ' + dismissals }}
            </p>
          </section>
        </div>
      </div>
    </div>
  `,
})
export class ComponentsShowcaseComponent {
  readonly exampleLogo = EXAMPLE_LOGO;
  clicks = 0;
  searches = 0;
  dismissals = 0;

  readonly dialogLines: string[] = [
    'O corpo rola sozinho quando o conteúdo passa da altura disponível.',
    'O cabeçalho e o rodapé ficam fixos, fora da área de rolagem.',
    'Repita esta linha o quanto quiser para ver a barra de rolagem aparecer.',
    'Cada linha existe só para dar altura ao exemplo.',
    'A largura vem do contêiner ao redor, não do componente.',
    'A última linha fecha o exemplo.',
  ];

  readonly entityOptions: SelectOption[] = [
    { value: '', label: 'Todas as lojas' },
    { value: '1', label: 'Loja Exemplo' },
  ];

  filterForm = new FormGroup({
    date: new FormControl<string>(''),
    entityId: new FormControl<string>('', { nonNullable: true }),
    plate: new FormControl<string>(''),
  });

  onHireClick(): void {
    this.clicks += 1;
  }

  onFilterSubmit(): void {
    this.searches += 1;
  }

  onDialogDismiss(): void {
    this.dismissals += 1;
  }
}
